<ng-container>
  <div *transloco="let t" class="cursor-pointer">
    @if (label) {
      <label class="trim-text">{{ t(label) }}
        @if (errors?.['required']) {
          <small>*</small>
        }
      </label>
    }
    <app-dropdown [disabled]="disabled || itemLabelArray.length === 0" (dropdownClosed)="dropdownClosed($event)"
                  [leftAlign]="leftAlign" [isDropdownListFullWidth]="isDropdownListFullWidth"
                  [isDarkDropdown]="isDarkDropdown">
      <div dropdownPanel>
        <div [class.is-small-dropdown]="isSmallDropdown"
             class="dropdown-height form-control d-flex {{cssClass ? cssClass : 'form-dropdown'}} align-items-center justify-content-between"
             dropdownToggle [ngClass]="{
          'error':  touched && invalid,
          'disabled': disabled,
          'ng-touched': touched,
          'ng-invalid ': touched && invalid
          }">
          <span class="wrap-text">
            {{ getSelectedValueLabel() }}
          </span>
        </div>
      </div>
      <div dropdownContent>
        @if (itemLabelArray.length > SEARCH_ELEMENT_BREAKPOINT) {
          <div class="px-0 mx-0 search-wrapper">
            <div class="d-flex align-items-center p-0 m-0 mx-4 pt-2">
              <i class="bi bi-search ps-1"></i>
              <input [placeholder]="t('explore.search')" class="search-input ps-2 d-flex" [ngModel]="searchText"
                     (ngModelChange)="onSearch($event)"/>
            </div>
          </div>
        }
        <div class="scrollable-list">
          <ul class="items-list px-0 mx-0 pb-2">
            @if (hasDefault) {
              <li (click)="setDefaultValue()" dropdownItem
                  class="d-flex align-items-center p-0 m-0 mx-4 py-2">
                <div class="d-flex justify-content-start align-items-center">
                  <div class="ps-2">
                    <span
                      [ngClass]="{'text-white':  isDarkDropdown && defaultValue !== selectedValue, 'color-primary':
                      defaultValue === selectedValue, 'fw-semibold':
                      defaultValue === selectedValue}">
                      {{ defaultLabel }}
                    </span>
                  </div>
                </div>
              </li>
            }
            @if (filteredItemLabelArray.length > 0) {
              @for (item of filteredItemLabelArray;track item.item;let idx = $index) {
                <li (click)="onSelect(item.item)" dropdownItem
                    class="d-flex align-items-center p-0 m-0 mx-4 py-2">
                  <div class="d-flex justify-content-start align-items-center">
                    <div class="ps-2">
                      <span
                        [ngClass]="{'text-white':  isDarkDropdown && item.item !== selectedValue, 'color-primary':
                        item.item === selectedValue, 'fw-semibold':
                        item.item === selectedValue}">
                        {{ item.label }}</span>
                    </div>
                  </div>
                </li>
              }
            } @else {
              <li class="d-flex align-items-center p-0 m-0 mx-4 pt-2"> {{ t("emptyState.not.able.to.find") }}
              </li>
            }
          </ul>
        </div>
      </div>
    </app-dropdown>
    @if (invalid && touched) {
      @for (errorMessage of errors | errorMessages;track errorMessage) {
        <span class="errorMes pt-1">{{ errorMessage }} </span>
      }
    }
  </div>
</ng-container>
